import * as React from 'react';
import { Paper, Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Status } from '../constants';
import AssetDataTableHOC from './AssetDataTable';
import Loading from '../components/loading/Loading';

const styles = {
  tab: {
    minWidth: 100,
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    textTransform: 'initial',
  },
};

function AssetDataOverviewHOC(Label: any, DataProperty: any, Configuration: any) {
  const AssetDataTable = AssetDataTableHOC(Label, DataProperty);
  const View = {
    [Status.New]: [Status.New],
    [Status.Requested]: [Status.Requested],
    [Status.RequestDeclined]: [Status.RequestDeclined],
    [Status.Offered]: [Status.Offered],
    [Status.OfferDeclined]: [Status.OfferDeclined],
    [Status.Accepted]: [Status.Accepted, Status.Scheduled],
    [Status.Expiring]: [Status.Expiring, Status.ExpiringReplaced],
    [Status.Suspended]: [Status.Suspended, Status.SuspendedReplaced],
  }
  class AssetDataOverview extends React.Component<any, any> {
    public state = {
      agreements: [],
      loading: true,
      view: View.New
    };

    public liveUpdate: any;

    public getAgreementsForStatusIds = (statusIds: string[]) => {
      return this.state.agreements.filter((subscription: any) =>
        statusIds.some(statusId => subscription.states[0].id === statusId)
      )
    };

    public getStatusFilterLabel = (statusId: any) => {
      return `${Label.Status[statusId]} (${this.getAgreementsForStatusIds(View[statusId]).length})`;
    };

    public onViewChange = (event: any, view: any) => {
      this.setState({ view });
    };

    public refreshData = async () => {
      this.setState({
        agreements: await Configuration.GetAgreements(this.props.assetId),
        loading: false,
      });
    }

    public componentDidMount() {
      this.refreshData();
    }

    public render() {
      if (this.state.loading) {
        return <Loading />;
      }

      const { view } = this.state;
      const { classes } = this.props;

      return (
        <Paper>
          <Tabs
            value={this.state.view}
            onChange={this.onViewChange}
            indicatorColor="secondary"
            textColor="secondary"
          >
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.New)}
              value={View[Status.New]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.Requested)}
              value={View[Status.Requested]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.RequestDeclined)}
              value={View[Status.RequestDeclined]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.Offered)}
              value={View[Status.Offered]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.OfferDeclined)}
              value={View[Status.OfferDeclined]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.Accepted)}
              value={View[Status.Accepted]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.Expiring)}
              value={View[Status.Expiring]}
            />
            <Tab
              className={classes.tab}
              label={this.getStatusFilterLabel(Status.Suspended)}
              value={View[Status.Suspended]}
            />
          </Tabs>
          <AssetDataTable
            agreements={this.getAgreementsForStatusIds(view)}
            view={view}
            basePath={this.props.basePath}
          />
        </Paper>
      );
    }
  }

  // @ts-ignore
  return withStyles(styles)(AssetDataOverview);
}

export default AssetDataOverviewHOC;



// WEBPACK FOOTER //
// ./src/modules/shared/dataSharing/AssetDataOverview.tsx